/*----------------------------------
- TLD PAGE: RADAR HANDOFF
----------------------------------*/

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { RADAR_CREATE_ACTION } from '@uniquedomains/components/contracts/upgrade/catalogs/featureActions';

import { buildProductFilterUrl } from '@/client/pages/landing/domains/page/lib/publicRadarQuery';
import { buildWebsiteAuthHref } from '@/client/utils/conversion/authHref';

/*----------------------------------
- CONSTANTS
----------------------------------*/

/** Signup attribution for every CTA of an insight page (`User.desiredFrom`). */
export const TLD_PAGE_ATTRIBUTION = 'website_tld_page';

/*----------------------------------
- PUBLIC API
----------------------------------*/

/**
 * The Product Browse search for one TLD (`/domains?tld=<slug>`), built with the public listing's
 * own filter bridge so the rule reads back into the product rail exactly as the listing's does.
 */
export const buildTldProductSearchPath = (slug: string): string =>
    buildProductFilterUrl({}, [{ filterId: 'tld', field: 'tld', op: 'IN', value: [slug] }]);

/**
 * "Create a Radar on .<tld>": signup on the Radar wall, returning to that TLD's Browse search,
 * where the new member saves the Radar (`website_tld_page_create_radar`, radar intent).
 */
export const buildTldRadarHref = (slug: string): string =>
    buildWebsiteAuthHref({
        flow: 'cold',
        mode: 'signup',
        from: TLD_PAGE_ATTRIBUTION,
        returnTo: buildTldProductSearchPath(slug),
        feature: 'radarsCount',
        action: RADAR_CREATE_ACTION,
    });
